/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'tax-document': {
    width: 64,
    height: 64,
    viewBox: '0 0 64 64',
    data: '<g fill-rule="evenodd"><path pid="0" d="M6 .071v63.637h30.776v-2.63H8.63V2.701h46.558v16.205h2.63V.071z"/><path pid="1" d="M55.188 18.741v26.824l-14.204-.058v15.571h-4.58v2.63h7.21v-15.56l14.204.057V18.741z"/><path pid="2" d="M43.18 63.708a1.315 1.315 0 01-.959-2.215L55.545 47.3a1.316 1.316 0 011.918 1.8L44.14 63.293a1.313 1.313 0 01-.96.415M22.308 37.412h25.515v-2.63H22.308zM17.048 37.412h2.63v-2.367h-2.63zM21.782 42.934h26.304v-2.63H21.782zM17.048 42.671h2.63v-2.367h-2.63zM21.519 48.456h17.886v-2.629H21.519zM17.048 48.193h2.63v-2.366h-2.63zM17.308 14.493h8.663v1.984h-3.169v8.383h-2.34v-8.383h-3.154v-1.984zM34.246 24.86l-.815-2.015h-4.798l-.815 2.015h-2.414l4.503-10.367h2.414l4.428 10.367h-2.503zm-4.843-3.896h3.273l-1.63-4.028-1.643 4.028zm8.097-6.471h2.725l2.162 3.169 2.177-3.17h2.77l-3.451 4.962 3.747 5.406h-2.8l-2.443-3.451-2.4 3.45h-2.739l3.717-5.301-3.465-5.065z"/></g>'
  }
})
